<template>
  <div class="col-12 px-0 b-page b-page_height_auto">
    <div class="b-page__content">
      <main class="b-main__inner">
        <div class="py-4 px-6 b-toolbar">
          <div class="b-toolbar__inner">
            <div class="mr-4 b-toolbar__item">
              <button
                class="b-btn b-btn_type_primary "
                @click="onClickCreateDiscountRate"
              >
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="plus" />
                {{$t('CONTENT.discountRates.add_new_discountRate')}}
              </button>
            </div>
            <div class="mr-4 b-toolbar__item">
              <button
                class="b-btn "
                @click="openImportDialog"
                v-tooltip="$t('CONTENT.hints.importDiscountHint')"
              >
                <dynamic-icon class="b-btn__icon" icon="xls"/>
                {{$t('CONTENT.import')}}
              </button>
            </div>
            <div class="b-toolbar__item">
              <button
                class="mr-4 b-btn  b-import__choose-btn"
                @click="downloadDiscountRateTemplate"
              >
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="download"/>
                {{$t('CONTENT.download_template')}}
              </button>
            </div>
            <div class="b-toolbar__item">
              <button
                class="b-btn  b-import__choose-btn"
                @click="downloadDiscountRates"
              >
                <dynamic-icon class="b-btn__icon b-btn__icon_color_white" icon="download"/>
                {{$t('CONTENT.export')}}
              </button>
            </div>
          </div>
        </div>
        <div class="b-table b-full-table b-full-table_type_short mx-6 mt-4 mb-10">
          <div class="b-table__row b-full-table__row b-full-table__row-header">
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$t('CONTENT.discountRates.rate')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$t('CONTENT.date')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell b-table__cell_width_md"
            >{{$t('CONTENT.assets.base_asset_type')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$t('CONTENT.discountRates.rent_period_in_months')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$t('CONTENT.discountRates.rent_sum')}}</div>
            <div
              class="b-table__cell b-full-table__cell b-full-table__header-cell"
            >{{$tc('CONTENT.currency.currency_code', 1)}}</div>
          </div>
          <div class="b-table__row b-full-table__row" v-for="discountRateItem in currentDiscountRates">
            <div class="b-table__cell b-full-table__cell b-full-table__cell_type_flex">
              <button v-if="!isReadOnlyMode" type="button" class="px-0 b-btn b-btn_type_empty b-btn__icon_color_main-text" @click="onClickEditDiscountRate(discountRateItem)">
                <dynamic-icon class="b-btn__icon" icon="edit"></dynamic-icon>
              </button>
              {{discountRateItem.value}}%
            </div>
            <div class="b-table__cell b-full-table__cell">{{discountRateItem.date | dateFormatted}}</div>
            <div class="b-table__cell b-full-table__cell b-table__cell_width_md">{{getAssetType(discountRateItem.underlyingAssetTypeId)}}</div>
            <div class="b-table__cell b-full-table__cell">{{$t('CONTENT.from')}} {{discountRateItem.monthsCountFrom}} {{$t('CONTENT.to')}} {{discountRateItem.monthsCountTo}}</div>
            <div class="b-table__cell b-full-table__cell">{{$t('CONTENT.from')}} {{convertDecimalToStringForChart(discountRateItem.rentalAmountFrom)}} {{$t('CONTENT.to')}} {{convertDecimalToStringForChart(discountRateItem.rentalAmountTo)}}</div>
            <div class="b-table__cell b-full-table__cell">{{discountRateItem.currencyCode}}</div>
          </div>
        </div>
      </main>
      <popup name="discountRate-import-popup" height="auto" :scrollable="true">
        <ImportDialogWidget
          v-if="isShowImportDialog"
          importType="discountRate"
          @close="closeImportDialog"
        ></ImportDialogWidget>
      </popup>
      <popup name="discountRate-popup" height="auto" :scrollable="true">
        <div data-cy="form-label" class="b-dialog__top-panel">
          <h2>{{$t('CONTENT.discountRates.create_discountRate')}}</h2>
          <button class="b-btn b-btn_border_none" @click.prevent="onClickCancel">
            <dynamic-icon icon="close" />
          </button>
        </div>
        <server-error v-if="error" :error="error"></server-error>
        <DiscountRateEditWidget
          v-if="isShowEditDialog"
          :currentDiscountRate="currentDiscountRate"
          :assetTypes="assetTypes"
          :currencyCodes="currencyCodes"
          @save="onClickSave($event)"
          @cancel="onClickCancel">
        </DiscountRateEditWidget>
      </popup>
    </div>
  </div>
</template>

<script>

import DiscountRateEditWidget from "./DiscountRateEditWidget";
import dateConverter from "../../../../utils/converters/date.converter";
import ImportDialogWidget from "../../../../components/widgets/ImportDialogWidget";
import downloadFileMixin from "../../../../mixins/downloadFile";
import convertDecimalForChart from "../../../../utils/converters/convert.decimal.for.chart";

export default {
  props: {
    assetTypes: {
      type: Array,
      required: true,
    },
    currencyCodes: {
      type: Array,
      required: true,
    },
    currentDiscountRates: {
      type: Array,
      required: true,
    },
    isReadOnlyMode: {
      type: Boolean,
    },
  },
  components: {
    DiscountRateEditWidget,
    ImportDialogWidget,
  },
  mixins: [downloadFileMixin],
  data() {
    return {
      isShowEditDialog: false,
      currentDiscountRate: null,
      error: null,
      isShowImportDialog: false,
    }
  },
  methods: {
    getAssetType(assetTypeId) {
      if(assetTypeId === null) {
        return 'Все';
      }
      for (let i = 0; i < this.assetTypes.length; i++) {
        if(this.assetTypes[i].idInDb === assetTypeId) {
          return this.assetTypes[i].name;
        }
      }
    },
    onClickEditDiscountRate(discountRate) {
      this.error = null;
      this.currentDiscountRate = discountRate;
      this.isShowEditDialog = true;
      this.$modal.show('discountRate-popup');
    },
    onClickCreateDiscountRate() {
      this.error = null;
      this.currentDiscountRate = null;
      this.isShowEditDialog = true;
      this.$modal.show('discountRate-popup');
    },
    async onClickSave(data) {
      this.error = null;
      if(data.idInDb === null) {
        try {
          await this.$store.dispatch('discountRatesPlugin/setDiscountRate', data);
          this.onClickCancel();
        } catch (e) {
          this.error = e;
        }
      } else {
        try {
          await this.$store.dispatch('discountRatesPlugin/editDiscountRate', data);
          this.onClickCancel();
        } catch (e) {
          this.error = e;
        }
      }
    },
    onClickCancel() {
      this.isShowEditDialog = false;
      this.$modal.hide('discountRate-popup');
    },
    openImportDialog() {
      this.isShowImportDialog = true;
      this.$modal.show('discountRate-import-popup');
    },
    closeImportDialog() {
      this.isShowImportDialog = false;
      this.$modal.hide('discountRate-import-popup');
    },
    downloadDiscountRateTemplate() {
      this.importType = "discountRate";
      this.downloadTemplate();
    },
    downloadDiscountRates() {
      this.importType = "allDiscountRates";
      this.downloadTemplate();
    },
    convertDecimalToStringForChart(decimal) {
      if(decimal === 0) {
        return 0;
      }
      return convertDecimalForChart(decimal);
    },
  }
};
</script>

